export class LoginRequest{
    public cpf: string;
    public password: string;
}